import * as React from "react";
import { useSelector } from "react-redux";
import { decode } from "html-entities";

export default function DocumentItem(props) {
  const document = props.document;

  const itemToggle = () => {
    if (
      props.selectedDocuments.filter((item) => {
        return item.nid === document.nid;
      }).length > 0
    ) {
      props.removeSelectedDocumentItem(document);
    } else {
      props.addSelectedDocumentItem(document);
    }
  };

  return (
    <div
      key={`document-item-${document.nid}`}
      className={`document-item ${
        props.selectedDocuments.filter((item) => {
          return item.nid === document.nid;
        }).length > 0
          ? "selected"
          : ""
      }`}
      onClick={() => itemToggle()}
    >
      {props.selectedDocuments.filter((item) => {
        return item.nid === document.nid;
      }).length > 0 && <div className="selected-document-item-marker"></div>}

      {props.selectedDocuments.filter((item) => {
        return item.nid === document.nid;
      }).length > 0 && (
        <svg
          className="selected-document-item-marker-check"
          focusable="false"
          aria-hidden="true"
          viewBox="0 0 24 24"
          data-testid="CheckIcon"
        >
          <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
        </svg>
      )}
      <div className="document-item-nid">#{document.nid}</div>
      <div className="document-item-title">{decode(document.title)}</div>
    </div>
  );
}
